import { isMemo, isFragment, isForwardRef } from 'react-is';
// eslint-disable-next-line @typescript-eslint/ban-types
function shouldConstruct(Component) {
  const prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}
// https://github.com/facebook/react/blob/ce13860281f833de8a3296b7a3dad9caced102e9/packages/react-reconciler/src/ReactFiber.new.js#L225
function isSimpleFunctionComponent(type) {
  return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
}
export function isSafeSetRefComponent(component) {
  if (!isForwardRef(component)) return false;
  if (isFragment(component)) return false;
  if (isMemo(component)) return isSafeSetRefComponent(component.type);
  return !isSimpleFunctionComponent(component.type);
}